<template>
<form @submit.prevent="submit">
    <p v-if="errors.length">Please correct the following errors:
        <ul>
            <li v-for="error in errors">{{error}}</li>
        </ul>
    </p>
    <div class="form-group"><label class="text-muted">Office Name:</label><span class="font-weight-bold"> {{office.office.name | capitalize}}</span></div>
    <div class="form-group"><textarea class="form-control" v-model="message"></textarea></div>
    <div class="form-group"><img src="@/assets/images/YouTube_Logo.png" />
        <div><span class="font-weight-bold youtubeTitle">How to Embed a YouTube Video</span>
            <p> When viewing the youtube video, click share, then click embed, then copy and paste here.</p>
        </div>
    </div>
    <div class="form-group text-right">
        <b-btn class="mr-2" size="sm" variant="success" type="button" @click="onSubmit()">Save</b-btn>
        <b-btn size="sm" @click="cancel()">Cancel</b-btn>
    </div>
</form>
</template>

<script>
import makesAjaxRequests from '@/mixins/makesAjaxRequests'
import api from '@/http'
export default {
  name: 'EditOfficeMessageForm',
  mixins: [makesAjaxRequests],
  props: {
    office: Object
  },
  data () {
    return {
      errors: [],
      message: this.office.message
    }
  },
  watch: {
    office: function (val) {
      this.message = val.message
    }
  },
  methods: {
    onSubmit () {
      api.postRequest('api/v1/office-message/' + this.office.id, {
        message: this.message
      }).then(resp => {
        this.$emit('close')
        this.errors = []
      }).catch(error => {
        this.errors = []
        if (error.response.data.errors.message) {
          this.errors.push(error.response.data.errors.message[0])
        }
      })
    },
    cancel () {
      this.$emit('close')
      this.message = this.office.message
    }
  }
}
</script>

<style scoped>
  .youtubeTitle {
    color: #7b009c;
  }
</style>
